import { memo, useState } from 'react';
import { cardSrc, parseCards } from './cards/cardUtils';
import { roundBook, fmtBook } from '../../utils/casinoBook';

const CDN = 'https://wver.sprintstaticdata.com/v230/static/front/img/cards';
const PLAYERS = [1, 2, 3, 4, 5, 6];

function findByNat(sub, nat) {
  return sub.find((s) => s.nat === nat);
}
function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}
function bookOf(exposures, name, sid) {
  return roundBook(exposures?.[`sid:${sid}`] ?? exposures?.[name] ?? 0);
}
function bookCls(v) {
  return v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black';
}

function getPlayerItems(sub, n) {
  return {
    winner: findByNat(sub, `Winner ${n}`),
    black: findByNat(sub, `Black ${n}`),
    red: findByNat(sub, `Red ${n}`),
    odd: findByNat(sub, `Odd ${n}`),
    even: findByNat(sub, `Even ${n}`),
    spade: findByNat(sub, `Spade ${n}`),
    club: findByNat(sub, `Club ${n}`),
    heart: findByNat(sub, `Heart ${n}`),
    diamond: findByNat(sub, `Diamond ${n}`),
  };
}

// info-circle + collapse range (R:100-<max>)
function RangeCollapse({ id, max }) {
  return (
    <div className="float-right">
      <i data-toggle="collapse" data-target={`#${id}`} className="fas fa-info-circle"></i>
      {' '}
      <div id={id} className="collapse icon-range">
        R:
        <span>100</span>
        -
        <span>{max}</span>
      </div>
    </div>
  );
}

const SUIT_IMG = {
  spade: `${CDN}/spade.png`,
  club: `${CDN}/club.png`,
  heart: `${CDN}/heart.png`,
  diamond: `${CDN}/diamond.png`,
};

// nation-name label variants
function NameWinner({ n }) { return <><b>Winner {n}</b></>; }
function SuitPair({ a, b }) {
  return <span><img src={SUIT_IMG[a]} /> <img src={SUIT_IMG[b]} /></span>;
}
function SuitOne({ s }) { return <span><img src={SUIT_IMG[s]} /></span>; }

const BackCell = memo(function BackCell({ item, onBet, exposures, bookClass }) {
  const susp = isSusp(item);
  const book = bookOf(exposures, item?.nat, item?.sid);
  return (
    <div className={`casino-bl-box${susp ? ' suspended' : ''}`}>
      <div
        className="back casino-bl-box-item"
        onClick={susp ? undefined : () => onBet(item.sid, 'back', item.b, item)}
      >
        <span className="casino-box-odd">{item?.b ?? 0}</span>
        {' '}
        <span className={`${bookClass} ${bookCls(book)}`.trim()}>{fmtBook(book)}</span>
      </div>
    </div>
  );
});

// Mobile tab panel: teen1dayleft (Winner/black/red/Odd/Even) + teen1dayright (4 suits).
// demo base = (n-1)*9; left 0-4, right 5-8.
function MobilePlayerTab({ p, n, onBet, exposures }) {
  const base = (n - 1) * 9;
  const B = '';
  return (
    <div className="teen1daycasino-container">
      <div className="teen1dayleft">
        <div className="casino-war-container">
          <div className="casino-box-row">
            <div className="casino-nation-name"><NameWinner n={n} /><RangeCollapse id={`demo-${base + 0}`} max="1L" /></div>
            <BackCell item={p.winner} onBet={onBet} exposures={exposures} bookClass={B} />
          </div>
          <div className="casino-box-row">
            <div className="casino-nation-name casino-card-img"><SuitPair a="spade" b="club" /><RangeCollapse id={`demo-${base + 1}`} max="25K" /></div>
            <BackCell item={p.black} onBet={onBet} exposures={exposures} bookClass={B} />
          </div>
          <div className="casino-box-row">
            <div className="casino-nation-name casino-card-img"><SuitPair a="heart" b="diamond" /><RangeCollapse id={`demo-${base + 2}`} max="25K" /></div>
            <BackCell item={p.red} onBet={onBet} exposures={exposures} bookClass={B} />
          </div>
          <div className="casino-box-row">
            <div className="casino-nation-name casino-card-img"><b>Odd {n}</b><RangeCollapse id={`demo-${base + 3}`} max="25K" /></div>
            <BackCell item={p.odd} onBet={onBet} exposures={exposures} bookClass={B} />
          </div>
          <div className="casino-box-row">
            <div className="casino-nation-name casino-card-img"><b>Even {n}</b><RangeCollapse id={`demo-${base + 4}`} max="25K" /></div>
            <BackCell item={p.even} onBet={onBet} exposures={exposures} bookClass={B} />
          </div>
        </div>
      </div>
      <div className="teen1daycenter"></div>
      <div className="teen1dayright">
        <div className="casino-war-container">
          <div className="casino-box-row">
            <div className="casino-nation-name casino-card-img"><SuitOne s="spade" /><RangeCollapse id={`demo-${base + 5}`} max="25K" /></div>
            <BackCell item={p.spade} onBet={onBet} exposures={exposures} bookClass={B} />
          </div>
          <div className="casino-box-row">
            <div className="casino-nation-name casino-card-img"><SuitOne s="heart" /><RangeCollapse id={`demo-${base + 6}`} max="25K" /></div>
            <BackCell item={p.heart} onBet={onBet} exposures={exposures} bookClass={B} />
          </div>
          <div className="casino-box-row">
            <div className="casino-nation-name casino-card-img"><SuitOne s="club" /><RangeCollapse id={`demo-${base + 7}`} max="25K" /></div>
            <BackCell item={p.club} onBet={onBet} exposures={exposures} bookClass={B} />
          </div>
          <div className="casino-box-row">
            <div className="casino-nation-name casino-card-img"><SuitOne s="diamond" /><RangeCollapse id={`demo-${base + 8}`} max="25K" /></div>
            <BackCell item={p.diamond} onBet={onBet} exposures={exposures} bookClass={B} />
          </div>
        </div>
      </div>
    </div>
  );
}

// Desktop market rows: label (with minmaxinfo range) + 6 winner columns.
// order: Winner, black(spade+club), red(heart+diamond), Odd, Even, spade, club, heart, diamond
const WEB_ROWS = [
  { key: 'winner', max: '1L', img: false, label: () => <b>Winner</b> },
  { key: 'black', max: '25K', img: true, label: () => <SuitPair a="spade" b="club" /> },
  { key: 'red', max: '25K', img: true, label: () => <SuitPair a="heart" b="diamond" /> },
  { key: 'odd', max: '25K', img: false, label: () => <b>Odd</b> },
  { key: 'even', max: '25K', img: false, label: () => <b>Even</b> },
  { key: 'spade', max: '25K', img: true, label: () => <SuitOne s="spade" /> },
  { key: 'club', max: '25K', img: true, label: () => <SuitOne s="club" /> },
  { key: 'heart', max: '25K', img: true, label: () => <SuitOne s="heart" /> },
  { key: 'diamond', max: '25K', img: true, label: () => <SuitOne s="diamond" /> },
];

const BetTableWar = memo(function BetTableWar({ gameData, onBet, exposures }) {
  const sub = gameData?.sub || [];
  const handleBet = onBet || (() => {});
  const [activeTab, setActiveTab] = useState(0);

  const codes = parseCards(gameData?.card ?? '');
  const playerCards = PLAYERS.map((_, i) => codes[i] || '1');
  const players = PLAYERS.map((n) => getPlayerItems(sub, n));

  return (
    <>
      {/* Mobile: cards + tabs */}
      <div className="teen1daycasino-container d-none-big">
        <div className="casino-war-container casino-war-cards">
          <div className="casino-box-row">
            {PLAYERS.map((n, i) => (
              <div key={n} className="casino-bl-box">
                <div className="casino-bl-box-item casino-card-img">
                  <span data-v-b64efdfa=""><img data-v-b64efdfa="" src={cardSrc(playerCards[i])} /></span>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="casino-tabs">
          <ul className="nav nav-tabs">
            {PLAYERS.map((n, i) => (
              <li key={n} className="nav-item">
                <a href={`#tab${n}`} data-toggle="tab" className={`nav-link${activeTab === i ? ' active' : ''}`} onClick={(e) => { e.preventDefault(); setActiveTab(i); }}>{n}</a>
              </li>
            ))}
          </ul>
        </div>
        <div className="tab-content w-100">
          {PLAYERS.map((n, i) => (
            <div key={n} id={`tab${n}`} className={`tab-pane${activeTab === i ? ' active' : ''}`}>
              <MobilePlayerTab p={players[i]} n={n} onBet={handleBet} exposures={exposures} />
            </div>
          ))}
        </div>
      </div>

      {/* Desktop: matrix (9 market rows x 6 winner cols) */}
      <div className="teen1daycasino-container d-none-small">
        <div className="casino-war-container">
          <div className="casino-box-row">
            <div className="casino-nation-name no-border"></div>
            {PLAYERS.map((n, i) => (
              <div key={n} className="casino-bl-box">
                <div className="casino-bl-box-item casino-card-img">
                  <span data-v-b64efdfa=""><img data-v-b64efdfa="" src={cardSrc(playerCards[i])} /></span>
                </div>
              </div>
            ))}
          </div>
          <div className="casino-box-row casino-war-title">
            <div className="casino-nation-name no-border"></div>
            {PLAYERS.map((n) => (
              <div key={n} className="casino-bl-box"><div className="casino-bl-box-item"><b>{n}</b></div></div>
            ))}
          </div>
          {WEB_ROWS.map((row, r) => {
            const Label = row.label;
            return (
              <div key={row.key} className="casino-box-row mb-4">
                <div className={`casino-nation-name${row.img ? ' casino-card-img' : ''}`}>
                  <Label />
                  <RangeCollapse id={`minmaxinfo${r}`} max={row.max} />
                </div>
                {players.map((p, i) => (
                  <BackCell key={PLAYERS[i]} item={p[row.key]} onBet={handleBet} exposures={exposures} bookClass="casino-book" />
                ))}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
});

export default BetTableWar;
